import React from 'react';

import VenueProfile from './component';

export default React.memo(VenueProfile);
